import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "content"]

  connect() {
    this.currentCandidateId = null
    this.dialogTarget.addEventListener("click", (e) => {
      if (e.target === this.dialogTarget) this.close()
    })
    this.dialogTarget.addEventListener("close", () => {
      this.releaseCandidateLock()
    })

    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  async open(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.candidateModalUrl
    const candidateId = event.currentTarget.dataset.candidateId
    await this.openUrl(url, candidateId)
  }

  async openUrl(url, candidateId = null) {
    if (!url) return
    this.currentCandidateId = candidateId
    this.acquireCandidateLock()
    this.contentTarget.innerHTML = '<div class="flex justify-center py-12"><div class="bounce-loader"><div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div></div></div>'
    this.dialogTarget.showModal()

    const response = await fetch(url)
    this.contentTarget.innerHTML = await response.text()
  }

  acquireCandidateLock() {
    if (!this.currentCandidateId) return
    const ch = this.findChannelController()
    if (ch && ch.lockCandidate) ch.lockCandidate(this.currentCandidateId)
  }

  releaseCandidateLock() {
    if (!this.currentCandidateId) return
    const ch = this.findChannelController()
    if (ch && ch.unlockCandidate) ch.unlockCandidate(this.currentCandidateId)
    this.currentCandidateId = null
  }

  findChannelController() {
    const el = this.element.closest("[data-controller~='workspace-channel']") || document.querySelector("[data-controller~='workspace-channel']")
    if (!el) return null
    return this.application.getControllerForElementAndIdentifier(el, "workspace-channel")
  }

  async changeTalkScript(event) {
    const select = event.currentTarget
    const talkScriptId = select.value
    const candidateId = select.dataset.candidateId
    const projectId = select.dataset.projectId
    const selectionListId = select.dataset.selectionListId

    const params = new URLSearchParams({ talk_script_id: talkScriptId })
    if (selectionListId) params.set("selection_list_id", selectionListId)
    const url = `/admin/projects/${projectId}/candidates/${candidateId}/preview?${params.toString()}`
    this.contentTarget.innerHTML = '<div class="flex justify-center py-12"><div class="bounce-loader"><div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div></div></div>'

    const response = await fetch(url)
    this.contentTarget.innerHTML = await response.text()
  }

  close() {
    this.dialogTarget.close()
  }
}
